import ImportCSVTool from 'tools/ImportCSVTool';

export const getRequiredMatchings = (matchings) => Object.entries(matchings).filter((matching) => matching[1].required);

export const getNoneRequiredMatchings = (matchings) => Object.entries(matchings).filter((matching) => !matching[1].required && !matching[1].site);

export const getSiteMatchings = (matchings) => Object.entries(matchings).filter((matching) => matching[1].site);

export const getSelectedMatchings = (matchings) => {
    const requiredMatchingsSelected = getRequiredMatchings(matchings).filter(matching => matching[1].header !== '');
    const noneRequiredMatchingsSelected = getNoneRequiredMatchings(matchings).filter(matching => matching[1].header !== '');
    const siteMatchings = getSiteMatchings(matchings).filter(matching => matching[1].header !== '');
    return requiredMatchingsSelected.concat(noneRequiredMatchingsSelected).concat(siteMatchings);
};

export const checkRequiredMatchings = (matchings) => {
    const requiredMatchings = getRequiredMatchings(matchings);
    let res = true;
    requiredMatchings.forEach(match => match[1].header ? match[1].errors.length > 0 ? res = false : null : res = false);
    return res;
};

export const getTranslation = (matching) => {
    if (matching[1].siteName) {
        return matching[1].siteName;
    }
    return matching[0];

};

export const isNumberType = (type) => type === 'Double' || type === 'Int';

export const testKeyUnicity = (keysToTest, items) => {
    const uniqueKeys = [];
    const duplicateKeys = [];

    const allKeys = items.map(i => {
        let itemKey = '';
        keysToTest.forEach(k => itemKey += i[k]);
        return itemKey;
    });

    allKeys.forEach(ak => {
        if (uniqueKeys.includes(ak)) {
            if (!duplicateKeys.includes(ak)) duplicateKeys.push(ak);
        } else {
            uniqueKeys.push(ak);
        }
    });

    return duplicateKeys;
};

export const getItems = (matchings, keys, importType, onlyKey) => {
    const selectedMatchings = getSelectedMatchings(matchings);
    const items = [];

    // Each parsedData of selected matching should have the same size so we select so we base our serialization on the size of first matching parsedData
    const nbArticle = selectedMatchings[0][1].parsedData.length;
    for (let articleIndex = 0; articleIndex < nbArticle; articleIndex++) {
        let item;
        if (importType === 'account') {
            item = [];
            if (!onlyKey) {
                selectedMatchings.forEach(matching => {
                    if (matching[1].parsedData[articleIndex]) {
                        item.push({ key: matching[0], value: matching[1].parsedData[articleIndex] });
                    } else {
                        item.push({ key: matching[0], value: '' });
                    }
                });
            } else {
                selectedMatchings.forEach(matching => {
                    // We add the attribute only if it's defined and if it's not a scraping data
                    if (keys.includes(matching[0])) {
                        if (matching[1].parsedData[articleIndex]) {
                            item.push({ key: matching[0], value: matching[1].parsedData[articleIndex] });
                        } else {
                            item.push({ key: matching[0], value: '' });
                        }
                    }
                });
            }
        } else {
            item = {};
            if (!onlyKey) {
                selectedMatchings.forEach(matching => {
                    if (matching[1].parsedData[articleIndex]) {
                        item[matching[0]] = matching[1].parsedData[articleIndex];
                    } else {
                        item[matching[0]] = '';
                    }
                });
            } else {
                selectedMatchings.forEach(matching => {
                    // We add the attribute only if it's defined and if it's not a scraping data
                    if (keys.includes(matching[0])) {
                        if (matching[1].parsedData[articleIndex]) {
                            item[matching[0]] = matching[1].parsedData[articleIndex];
                        } else {
                            item[matching[0]] = '';
                        }
                    }
                });
            }
            if (importType === 'additionalData') {
                ImportCSVTool.getAdditionalDatasName().forEach(data => {
                    if (!item[data]) item[data] = '';
                });
            }
        }

        items.push(item);
    }
    return items;
};

const bannedAttributesNames = [
    'name',
    'category',
    'category_name',
    'category_id',
    'cms_product_id',
    'cms_last_known_stock',
    'img_url',
    'img_path',
    'repriced_price',
    'applied_rule',
    'not_applicable_rules',
    'rrp',
    'pp',
    'purchasing_price',
    'purchasing price',
    'rrp_alert_percentage',
    'rrp_alert_factor',
    'your_url'
];

export const verifyBannedNames = (attributeName) => bannedAttributesNames.includes(attributeName);
